/**
 * SetupBonusBanner
 * Dismissible celebratory banner shown after first subscription (setup bonus active).
 * Only visible to admins when billing is enabled and setup_bonus_active is true.
 */
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useBilling } from '../../contexts/BillingContext';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from '../../i18n';

const DISMISSED_KEY = 'setup_bonus_banner_dismissed';

export function SetupBonusBanner() {
  const { trialInfo, billingVisible, isEnterprise } = useBilling();
  const { user } = useAuth();
  const { t } = useTranslation();
  const isAdmin = user?.role?.toUpperCase() === 'ADMIN';

  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === 'true'
  );

  if (
    !trialInfo?.setup_bonus_active ||
    !billingVisible ||
    isEnterprise ||
    !isAdmin ||
    dismissed
  ) {
    return null;
  }

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div className="rounded-lg border border-emerald-300 dark:border-emerald-700 bg-emerald-50 dark:bg-emerald-950/60 px-4 py-3 flex items-start gap-3 animate-in slide-in-from-top duration-300">
      <span className="text-lg shrink-0 mt-0.5" role="img" aria-label="celebration">
        🎉
      </span>
      <div className="flex-1 text-sm text-emerald-800 dark:text-emerald-200">
        <span className="font-semibold">{t('billing.setup_bonus_title')} </span>
        {t('billing.setup_bonus_description')}
      </div>
      <button
        onClick={handleDismiss}
        className="text-emerald-600 dark:text-emerald-400 hover:text-emerald-800 dark:hover:text-emerald-200 p-0.5"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
